import { Module } from "vuex";
import { RootState } from "@/store/RootState";
import { mutations } from "@/components/player/store/mutations";
import { getters } from "@/components/player/store/getters";
import { actions } from "@/components/player/store/actions";
import { PlayerState } from "@/components/player/types";

export const state: PlayerState = {
  pause: false
};

export const player: Module<PlayerState, RootState> = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
